import {
  MODEL_TYPE
} from './model_types'
import enumConstants from './../enumConstants'

export const PAYMENT_MODEL_TYPE_TO_MODEL_TYPE = {
  [enumConstants.payment_model_types.SALES_INVOICE]: MODEL_TYPE.SALES_INVOICE,
  [enumConstants.payment_model_types.SALES_CREDIT_MEMO]: MODEL_TYPE.SALES_CREDIT_MEMO,
  [enumConstants.payment_model_types.SALES_FINANCE_CHARGE]: MODEL_TYPE.SALES_FINANCE_CHARGE,
  [enumConstants.payment_model_types.SALES_ADVANCE_INVOICE]: MODEL_TYPE.SALES_ADVANCE_INVOICE,
  [enumConstants.payment_model_types.SALES_ORDER]: MODEL_TYPE.SALES_ORDER,
  [enumConstants.payment_model_types.SALES_RETURN_ORDER]: MODEL_TYPE.SALES_RETURN_ORDER,
  [enumConstants.payment_model_types.SALES_RETAIL_TRANSACTION]: MODEL_TYPE.SALES_RETAIL_TRANSACTION,
  [enumConstants.payment_model_types.SALES_RETAIL_REFUND_TRANSACTION]: MODEL_TYPE.SALES_RETAIL_REFUND_TRANSACTION,
  [enumConstants.payment_model_types.PURCHASE_INVOICE]: MODEL_TYPE.PURCHASE_INVOICE,
  [enumConstants.payment_model_types.PURCHASE_CREDIT_MEMO]: MODEL_TYPE.PURCHASE_CREDIT_MEMO,
  [enumConstants.payment_model_types.PURCHASE_FINANCE_CHARGE]: MODEL_TYPE.PURCHASE_FINANCE_CHARGE,
  [enumConstants.payment_model_types.PURCHASE_ADVANCE_INVOICE]: MODEL_TYPE.PURCHASE_ADVANCE_INVOICE,
  [enumConstants.payment_model_types.PURCHASE_ORDER]: MODEL_TYPE.PURCHASE_ORDER,
  [enumConstants.payment_model_types.PURCHASE_RETURN_ORDER]: MODEL_TYPE.PURCHASE_RETURN_ORDER,
  [enumConstants.payment_model_types.PURCHASE_RETAIL_TRANSACTION]: MODEL_TYPE.PURCHASE_RETAIL_TRANSACTION,
  [enumConstants.payment_model_types.PURCHASE_RETAIL_REFUND_TRANSACTION]: MODEL_TYPE.PURCHASE_RETAIL_REFUND_TRANSACTION,
  [enumConstants.payment_model_types.SERVICE_INVOICE]: MODEL_TYPE.SERVICE_INVOICE,
  [enumConstants.payment_model_types.SERVICE_ORDER]: MODEL_TYPE.SERVICE_ORDER
}

export const PAYMENT_MODEL_TYPE_MAPPER = {
  PAYMENT_MODEL_TYPES: {
    [enumConstants.payment_types.PAYMENT]: [
      enumConstants.payment_model_types.SALES_INVOICE,
      enumConstants.payment_model_types.SALES_FINANCE_CHARGE,
      enumConstants.payment_model_types.SALES_ADVANCE_INVOICE,
      enumConstants.payment_model_types.SALES_ORDER,
      enumConstants.payment_model_types.SALES_RETAIL_TRANSACTION,
      enumConstants.payment_model_types.PURCHASE_CREDIT_MEMO,
      enumConstants.payment_model_types.PURCHASE_RETURN_ORDER,
      enumConstants.payment_model_types.PURCHASE_RETAIL_REFUND_TRANSACTION,
      enumConstants.payment_model_types.SERVICE_INVOICE,
      enumConstants.payment_model_types.SERVICE_ORDER
    ],
    [enumConstants.payment_types.PAYOUT]: [
      enumConstants.payment_model_types.SALES_CREDIT_MEMO,
      enumConstants.payment_model_types.SALES_RETURN_ORDER,
      enumConstants.payment_model_types.SALES_RETAIL_REFUND_TRANSACTION,
      enumConstants.payment_model_types.PURCHASE_INVOICE,
      enumConstants.payment_model_types.PURCHASE_FINANCE_CHARGE,
      enumConstants.payment_model_types.PURCHASE_ADVANCE_INVOICE,
      enumConstants.payment_model_types.PURCHASE_ORDER,
      enumConstants.payment_model_types.PURCHASE_RETAIL_TRANSACTION
    ]
  }
}
